import React from "react";
import { ListFilterView } from "./view";
import { styles } from "./styles";

export class ListFilter extends React.Component {
  render() {
    return <ListFilterView {...this.props} styles={styles} />;
  }
}
